import { ReactElement } from 'react';
import { SessionViewProps } from './container';
import { TopologyTabContent } from './components/TabContent/TopologyTabContent';
import { ActionsBarWrapper } from './components/TabContent/ActionsBarWrapper';
import { useResetSessionActiveTab } from './hooks/useResetSessionActiveTab';
import { useSetDocumentTitle } from './hooks/useSetDocumentTitle';
import { LaunchPanelTabContentWrapper } from './components/TabContent/LaunchPanelTabContentWrapper';

export function SessionView({
  sessionActiveTab,
  setSessionActiveTab,
}: SessionViewProps): ReactElement {
  useSetDocumentTitle();
  useResetSessionActiveTab({ setSessionActiveTab });

  return (
    <>
      <ActionsBarWrapper />
      <TopologyTabContent sessionActiveTab={sessionActiveTab} />
      <LaunchPanelTabContentWrapper />
    </>
  );
}
